import { createSelector } from 'reselect';

const selectFile = (state) => state.file;

const selectUploadedFile = createSelector(selectFile, (file) => file?.uploaded);

const selectDeletedFile = createSelector(selectFile, (file) => file?.deleted);

const selectFileBlob = createSelector(selectFile, (file) => file?.blob);

const fileSelectors = {
	selectFile,
	selectUploadedFile,
	selectDeletedFile,
	selectFileBlob,
};

export default fileSelectors;
